import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const AccountsBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Accounts"
      sectionDisplayName="Accounts Section"
      backRoute="/sections/accounts"
    />
  );
};

export default AccountsBundleReceiptEntry;
